import { trpc } from "@/lib/trpc";
import { useFeature } from "@/lib/use-feature";
import { usePermissao } from "@/lib/use-permissao";
import type { BloqueioDoCatalogo, ItemDaBase } from "./NovoProcedimentoDialog";
import { ehDaFace, type Procedimento } from "./SeletorDeProcedimento";
import { useAdicionarAoCatalogo } from "./use-adicionar-ao-catalogo";

/**
 * O que o "Adicionar procedimento" oferece no modo atual: o catálogo da clínica e a base que ela
 * ainda não tem. Escolher da base adiciona ao catálogo quando pode (gerencia a clínica e tem o
 * catálogo, que é pago); senão vira item livre só com o nome, a cor e a unidade da base.
 */
export function useCatalogoDoItem({
  modoFace,
  onEscolher,
  onDesfeito,
}: {
  modoFace: boolean;
  onEscolher: (p: Procedimento) => void;
  onDesfeito: (serviceId: string) => void;
}) {
  const catalogo = trpc.plano.procedimentos.useQuery(undefined, { staleTime: 60_000 });
  const base = trpc.plano.daBase.useQuery(undefined, { staleTime: 60_000 });
  const temCatalogo = useFeature("clinicServices");
  const podeGerir = usePermissao("settings.manage");
  const bloqueio: BloqueioDoCatalogo = !temCatalogo ? "plano" : !podeGerir ? "permissao" : null;
  const adicionar = useAdicionarAoCatalogo(onDesfeito);

  const daBase = (base.data ?? []) as ItemDaBase[];
  return {
    procedimentos: ((catalogo.data ?? []) as Procedimento[]).filter((p) => ehDaFace(p) === modoFace),
    daBase,
    nomesDoCatalogo: ((catalogo.data ?? []) as Procedimento[]).map((p) => p.name),
    bloqueio,
    ocupado: adicionar.ocupado,
    escolherDaBase: async (b: ItemDaBase) => {
      if (bloqueio) {
        // Item livre: o procedimento não existe na clínica, então vai sem vínculo (id vazio).
        return onEscolher({ id: "", name: b.nome, especialidade: b.especialidade, priceCents: 0, color: b.cor, cobradoPorDente: b.cobradoPorDente, unidade: b.unidade });
      }
      try {
        onEscolher(await adicionar.adicionarDaBase(b.id));
      } catch {
        // o toast de erro vem da mutation
      }
    },
  };
}
